import { render } from "./SpecimenType.vue?vue&type=template&id=2c7c8fe8&scoped=true"
import script from "./SpecimenType.vue?vue&type=script&lang=js"
export * from "./SpecimenType.vue?vue&type=script&lang=js"

import "./SpecimenType.vue?vue&type=style&index=0&id=2c7c8fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7c8fe8"]])

export default __exports__